import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4384c624"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "car-box" }
const _hoisted_2 = { class: "card-box" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "flex-box align-center justify-between" }
const _hoisted_5 = { class: "title-label" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "来访车辆", -1))
const _hoisted_7 = {
  key: 0,
  class: "c-label-must"
}
const _hoisted_8 = { class: "title-value flex-box align-center" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "car-list"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "car-item-rank" }
const _hoisted_13 = { class: "car-item-num" }
const _hoisted_14 = { class: "car-item-name ellipsis" }
const _hoisted_15 = { class: "car-item-tel" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "empty-box"
}
const _hoisted_18 = { class: "add-line" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-add" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-text" }, "添加车辆", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "form-tip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_area = _resolveComponent("form-area")!
  const _component_c_modal = _resolveComponent("c-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.must)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "common-btn primary rec-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.recNum && _ctx.recNum(...args)))
              }, "识别"),
              _createElementVNode("span", null, _toDisplayString(_ctx.list.length), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.list && _ctx.list.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (c, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: (c.key as string),
                    class: "car-item flex-box align-center",
                    onClick: ($event: any) => (_ctx.editCar(i))
                  }, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(i + 1), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(c.num), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(c.name), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(c.tel), 1),
                    _createElementVNode("div", {
                      class: "car-item-remove icon-delete",
                      onClick: _withModifiers(($event: any) => (_ctx.removeCar(i)), ["stop"])
                    }, null, 8, _hoisted_16)
                  ], 8, _hoisted_11))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, "暂无信息"))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: "flex-box align-center",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showAdd && _ctx.showAdd(...args)))
        }, _hoisted_21)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_c_modal, {
        ref: "modal",
        title: "添加车辆信息",
        "on-confirm": _ctx.confirmAdd
      }, {
        default: _withCtx(() => [
          _createVNode(_component_form_area, {
            ref: "formRef",
            config: (_ctx.formConfig[_ctx.formType] as FormItem[]),
            value: _ctx.initial,
            "button-text": ""
          }, null, 8, ["config", "value"]),
          (_ctx.formType == 'input')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 注：申请通过将短信通知该人员，扫描寺方人员提供的 接待二维码，凭访客二维码通行。 "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["on-confirm"])
    ]))
  ], 64))
}